import { isValidElement } from 'react'

export const validateNativeSelectOptionElement = <
  T extends { value: string | number },
>(
  element: React.ReactElement<T>,
): React.ReactElement<T> | undefined => {
  if (!('value' in element.props)) {
    throw new Error('NativeSelect option must have a value prop')
  }

  if (!('as' in element.props) || element.props.as !== 'option') {
    throw new Error(
      'NativeSelect option component must be cast to an option element',
    )
  }

  if (!isValidElement(element)) {
    throw new Error('NativeSelect option must be a valid element')
  }

  return element
}
